import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("sl_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, referralCode = null, opts = {}) => {
    const payload = { name, email, password };
    if (referralCode) payload.referral_code = referralCode.toUpperCase().trim();
    if (opts.phone) payload.phone = opts.phone.trim();
    if (opts.country) payload.country = opts.country.toUpperCase().trim();
    if (opts.preferred_corridor) payload.preferred_corridor = opts.preferred_corridor.toLowerCase().trim();
    const { data } = await api.post("/auth/register", payload);
    if (data.token) localStorage.setItem("sl_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_e) { /* ignore */ }
    localStorage.removeItem("sl_token");
    setUser(null);
  };

  const updateProfile = async (patch) => {
    const { data } = await api.patch("/auth/me", patch);
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
